
import React, { useState } from 'react';
import useMounted from '../../hooks/useMounted';
import { post } from '../../helpers/api_helper';
import { amountFormatUse } from '../../helpers/Helper';
import { GET_ADMIN_DASHBOARD_DATA } from '../../helpers/url_helper';
import { toast } from 'react-toastify';

const Dashboard = (props) => {
    const [totalUser, SetTotalUser] = useState(0);
    const [monthlyIncome, SetMonthlyIncome] = useState(0);
    const [yearIncome, SetYearIncome] = useState(0);
    const [lifetimeIncome, SetLifetimeIncome] = useState(0);
    const [totalChequeIssued, SetTotalChequeIssued] = useState(0);
    const [totalPendingOrder, SetTotalPendingOrder] = useState(0);
    const [chequeIssuedList, SetChequeIssuedList] = useState([]);

    useMounted(() => {
        async function get_detaile() {
            var res_data = await post(GET_ADMIN_DASHBOARD_DATA, { offset: new Date().getTimezoneOffset() });
            if (res_data.status) {
                SetTotalUser(res_data.data.totalUser);
                SetMonthlyIncome(res_data.data.monthlyIncome);
                SetYearIncome(res_data.data.yearIncome);
                SetLifetimeIncome(res_data.data.lifetimeIncome);
                SetTotalChequeIssued(res_data.data.totalChequeIssued);
                SetTotalPendingOrder(res_data.data.totalPendingOrder);
                SetChequeIssuedList(res_data.data.chequeIssuedList);
            } else {
                toast.error(res_data.message);
            }
        }
        get_detaile();
    }, [])

    return (
        <>

            <div className="row">
                <div className="col-sm-6 col-lg-3 mb-4">
                    <div className="card card-border-shadow-primary h-100">
                        <div className="card-body">
                            <div className=" mb-2 pb-1 text-center">
                                <h4 className="ms-1 mb-2">{totalUser}</h4>
                                <p className="mb-0">Total Users</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 col-lg-3 mb-4">
                    <div className="card card-border-shadow-primary h-100">
                        <div className="card-body">
                            <div className=" mb-2 pb-1 text-center">
                                <h4 className="ms-1 mb-2">{amountFormatUse(monthlyIncome)}</h4>
                                <p className="mb-0">Current Month Income</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 col-lg-3 mb-4">
                    <div className="card card-border-shadow-primary h-100">
                        <div className="card-body">
                            <div className=" mb-2 pb-1 text-center">
                                <h4 className="ms-1 mb-2">{amountFormatUse(yearIncome)}</h4>
                                <p className="mb-0">Current Year Income</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 col-lg-3 mb-4">
                    <div className="card card-border-shadow-primary h-100">
                        <div className="card-body">
                            <div className=" mb-2 pb-1 text-center">
                                <h4 className="ms-1 mb-2">{amountFormatUse(lifetimeIncome)}</h4>
                                <p className="mb-0">Lifetime Income</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-3 mb-4">
                    <div className="card card-border-shadow-primary h-100">
                        <div className="card-body">
                            <div className=" mb-2 pb-1 text-center">
                                <h4 className="ms-1 mb-2">{totalChequeIssued}</h4>
                                <p className="mb-0">Total Cheque Issued</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-3 mb-4">
                    <div className="card card-border-shadow-primary h-100">
                        <div className="card-body">
                            <div className=" mb-2 pb-1 text-center">
                                <h4 className="ms-1 mb-2">{totalPendingOrder}</h4>
                                <p className="mb-0">Total Pending Order</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {chequeIssuedList.length > 0 &&
                <div className='row mb-4'>
                    <div className='col-sm-12'>
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body">
                                <div>
                                    <h6>Cheque Issued</h6>
                                </div>
                                <div className='table-responsive'>
                                    <table className='table tabl-sm table-striped'>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>User Name</th>
                                                <th>Bank Name</th>
                                                <th>Name</th>
                                                <th>Amount</th>
                                                <th>Date</th>
                                                <th>Cheque Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {chequeIssuedList.map((data) => {
                                                return (
                                                    <tr key={data.chequeId}>
                                                        <td>{data.chequeId}</td>
                                                        <td>
                                                            <span className='text-primary pointer' onClick={() => { window.open('/admin/users/view/' + data.userId, '_blank'); }}>{data.userName} </span>
                                                        </td>
                                                        <td>{data.bankName}</td>
                                                        <td>{data.name}</td>
                                                        <td>{amountFormatUse(data.amount)}</td>
                                                        <td>{data.date}</td>
                                                        <td>{data.chequeType}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    );
}

export default Dashboard;